<template>
  <div class="container is-fluid">
    
    <h1 class="title">Add a New Contact</h1>
    <div class="box ">	
      
      <div class="columns">
        <div class="field column">
          <label class="label">First Name</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="contact.forename" @change="getExistingContactsByName()" required>
          </div>
        </div>
        <div class="field column">
          <label class="label">Surname</label>
          <div class="control">
            <input class="input" type="text" placeholder=""  v-model="contact.surname" @change="getExistingContactsByName()" required>
          </div>
        </div>
      </div>
      <div class="notification is-warning" v-if="existingContactsByName.length > 0">
      There are one or more contacts in the database already that match the name entered.
      </div>
      <div class="columns">
        <div class="field column">
          <label class="label">Company</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="contact.company">
          </div>
        </div>
        <div class="field column">
          <label class="label">Job Title</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="contact.job_title">
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="field column">
          <label class="label">Email</label>
          <div class="control">
            <input class="input" type="email" placeholder="" v-model="contact.email" @change="getExistingContactsByEmail()">
          </div>
        </div>
        <div class="field column">
          <label class="label">Mobile Number</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="contact.mobile">
          </div>
        </div>
      </div>

      <div class="notification is-warning" v-if="existingContactsByEmail.length > 0">
      There are one or more contacts in the database already that match the email address entered.
      </div>

     

      <div class="field is-grouped">
        <p class="control">
          <a class="button is-success" @click.prevent="saveContact()" :disabled="saving===1">
            Save
          </a>
         
        </p>
       
      </div>


    </div>
	     

  </div>
</template>

<script>


import ContactService from '@/services/ContactService.js';
import UtilityService from '@/services/UtilityService.js';

export default {
  components: {
   	
  },
  data() {
    return {
      errors: [],
      contact: { "forename" : "",
      "surname" : "",
      "email" : "",
      "mobile" : "" ,
      "company" : "",
      "job_title" : ""},
      accessToken: '',
      existingContactsByEmail: [],
      existingContactsByName : [],
      saving:0
    }
  },
  

  // Fetches posts when the component is created.
  created() {
    this.getAccessToken()
    .then(() => { 
     
    });
  },
  watch: {
    
  },
  methods: {
  	async saveContact() {
        this.saving = 1;
        ContactService.saveContact(this.accessToken, this.contact)
        .then(
          (response => {
          this.$router.push("/contacts/" + response.id);
          })
        )
        .catch(error => {
          alert("An error occured - " + error.message)
          console.error(error.message);
          this.saving=0;
        });
      },
      async getExistingContactsByEmail() {
        UtilityService.getSimpleApiData(this.accessToken, "contacts?email=" + this.contact.email).then(
          response => this.existingContactsByEmail = response 
        );
      
      },
       async getExistingContactsByName() {
        UtilityService.getSimpleApiData(this.accessToken, "contacts?forename=" + this.contact.forename + '&surname=' + this.contact.surname).then(
          response => this.existingContactsByName = response 
        );
      
      }
    }
}

</script>

<style>
	
</style>
